import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientVaccineControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveVaccine = () =>
  useMutationWithLoading(
    async (param: {
      patientVaccineId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientVaccineControllerApi(
        getConfigObject()
      ).updatePatientVaccineArchiveStatus(
        param.patientVaccineId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );

  export const useArchiveVaccineMutation = () =>
    useMutationWithLoading(
      async (param: ArchiveMutation) =>
        new PatientVaccineControllerApi(
          getConfigObject()
        ).updatePatientVaccineArchiveStatus(
          param.id,
          param.status,
          param.xTENANTID //xTENANTID
        )
    );